module.exports = __webpack_public_path__ + "static/img-14-c437d9243fdb745c5dfba823c982abe7.jpeg";